

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

@Component({
    computed: {
        ...mapState(['parliament']),
        ...mapGetters(['partyByID', 'diffResult']),
    },
})
export default class SeatTable extends Vue {}
